/* eslint-disable no-unused-vars */
import React from 'react';
import { Route, Link, Redirect, BrowserRouter as Router, Switch } from 'react-router-dom';
import 'bootstrap/dist/css/bootstrap.min.css';
import { Table, Modal, Toast, Row, Col, OverlayTrigger, Popover } from 'react-bootstrap';
import JoditEditor from "jodit-react";
import Moment from 'moment';

// const titleKey = 'titlekey';
// const descKey = 'desckey';
// const schoolTagKey = 'stk';
// const projectTagKey = 'ptk';
// const countryTagKey = 'ctk';
// const themeTagKey = 'ttk';
//const BannerImgKey = 'bnk';
// const LeaderNameKey = 'lnk';
// const StartDateKey = 'sdk';
// const EndDateKey = 'edk';
// const fbKey = 'fbk';
// const igKey = 'igk';

class FormData extends React.Component {
    constructor(props) {
        super();
        this.state = {
            apiUrl: window.$apiUrl,
            FormData: props.Data,
            CountryList: [],
            ProjectList: [],
            SchoolList: [],
            ThemeList: [],
            file: "",
            config: {
                removeButtons: ['source', 'strikethrough', 'superscript', 'subscript', 'brush', 'image', 'file', 'video', 'symbol', 'fullsize', 'print', 'preview', 'find', 'about', 'table', 'paragraph'],
                height: 300,
                showXPathInStatusbar: false,
                showCharsCounter: false,
                showWordsCounter: true,
                toolbarAdaptive: false
            },
            FilledForm:{
                title: '',
                description:'',
                countryTag: '',
                projectTag: '',
                schoolTag: '',
                themeTag: '',
                imgPreview:'',
                leaderName:'',
                startDate: '',
                endDate: '',
                fbLink: '',
                igLink: '',
            }
        };

        this.handleFieldValue = this.handleFieldValue.bind(this);
        this.handleJoditField = this.handleJoditField.bind(this);
        this.fileUpload = this.fileUpload.bind(this);
        this.GoToPreview = this.GoToPreview.bind(this);
        this.submitForm = this.submitForm.bind(this);

        this.recaptchaRef = React.createRef();
    }

    GoToPreview() {
        this.props.GoToPreview(this.state.FilledForm);
    }

    fileUpload(e, index) {
        var fileName = e.target.files[0].name.split('.').slice(0, -1).join('.');
        var re = /^[0-9a-zA-Z\_\- ]+$/;

        if (e.target.files[0] && re.test(fileName)) {
            let FilledForm = this.state.FilledForm;
            let FormData = this.state.FormData;
            this.setState({ file: e.target.files[0] });
            this.props.FileUpload(e.target.files[0]);
            FormData[index].value = e.target.files;
            FormData[index].touched = true;
            
            var reader = new FileReader();

            reader.onload = (e) => {
                document.querySelector("#loadImage").setAttribute('src', e.target.result);
                FilledForm.imgPreview = e.target.result;
                this.setState({ FormData: FormData, FilledForm: FilledForm  });
                //localStorage[BannerImgKey] = e.target.result;
            }
            reader.readAsDataURL(e.target.files[0]);
        } else {
            e.target.value = "";
            alert("A file name cannot contain any of the following characters \\ / : * ? \" < > | # { } % ~ &");
        }
    }

    handleJoditField(value, index) {
        let FormData = this.state.FormData;
        FormData[index].value = value;
        FormData[index].touched = true;
        // if (index === 7) {
           
        // }
        if (value === "") {
            FormData[index].error = true;
        }
        this.setState({ FormData: FormData });
    }

    handleFieldValue(e, index, refName) {
        let name = e.target.name;
        let value = e.target.value;
        let type = e.target.type;
        let FormData = this.state.FormData;
        let FillForm =  this.state.FilledForm;

        const emailRegexp = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;

        switch (type) {
            case 'select-one':
                var selectedIndex = e.nativeEvent.target.selectedIndex;
                FormData[index].value = value;
                if (value === 'Others') {
                    FormData[index].isOtherField = true;
                } else {
                    FormData[index].isOtherField = false;
                }

                if (name === 'Country_ID') {
                    FillForm.countryTag = e.nativeEvent.target[selectedIndex].text;
                } else if (name === 'Project_ID') {
                    FillForm.projectTag = e.nativeEvent.target[selectedIndex].text;
                } else if (name === 'School_ID') {
                    FillForm.schoolTag = e.nativeEvent.target[selectedIndex].text;
                } else if (name === 'Theme_ID') {
                    FillForm.themeTag = e.nativeEvent.target[selectedIndex].text;
                }

                break;
            case 'email':
                if (emailRegexp.test(value)) {
                    FormData[index].value = value;
                    FormData[index].touched = true;
                } else {
                    FormData[index].value = "";
                    FormData[index].touched = true;
                }
                break;
            case 'date':
                if (name === 'Trip_StartDate') {
                    FormData[index].value = value;
                    FormData[index].touched = true;
                    FillForm.startDate = value;
                } else if (name === 'Trip_EndDate') {
                    FormData[index].value = value;
                    FormData[index].touched = true;
                    FillForm.endDate = value;
                }
                break;
            default:
                if(name === 'Story_Description'){
                    var count_word = value.trim().split(/\s+/).length;
                    if(count_word <= 25){
                        FormData[index].value = value;
                        FormData[index].touched = true;
                    }else{
                      return false;
                    }
                }else{
                    FormData[index].value = value;
                    FormData[index].touched = true;
                }
               
        }

        if (name === 'Story_Title') {
            FillForm.title = value;
        } else if (name === 'Contact_Name') {
            FillForm.leaderName = value;
        }else if(name === 'Story_Description'){
            var count_word = value.trim().split(/\s+/).length;
            if(count_word <= 25){
                FillForm.description = value;  
            }else{
              return false;
            }
        }else if(name === 'Story_FacebookURL'){
            FillForm.fbLink = value;
        }else if(name === 'Story_InstagramURL'){
            FillForm.igLink = value;
        }

        if (value === "") {
            FormData[index].error = true;
        }
        this.setState({ FormData: FormData });
    }

    getCountry() {
        fetch(this.state.apiUrl + '/CommonAPI/GetCountry', {
            method: 'POST',
            headers: {
                'token': process.env.REACT_APP_API_TOKEN,
                'Content-Type': 'application/json; charset=utf-8',
                'access-control-allow-origin': '*'
            },
            body: JSON.stringify({
                "ID": null
            })
        })
            .then(res => res.json())
            .then((data) => {
                if (data.Status === 'OK') {
                    this.setState({ CountryList: data.ListingDetail });
                }

            })
            .catch(console.log);
    }

    GetProject() {
        fetch(this.state.apiUrl + '/CommonAPI/GetProject', {
            method: 'POST',
            headers: {
                'token': process.env.REACT_APP_API_TOKEN,
                'Content-Type': 'application/json; charset=utf-8',
                'access-control-allow-origin': '*'
            },
            body: JSON.stringify({
                "ID": null
            })
        })
            .then(res => res.json())
            .then((data) => {
                if (data.Status === 'OK') {
                    this.setState({ ProjectList: data.ListingDetail });
                }
            })
            .catch(console.log);
    }

    GetSchool() {
        fetch(this.state.apiUrl + '/CommonAPI/GetSchool', {
            method: 'POST',
            headers: {
                'token': process.env.REACT_APP_API_TOKEN,
                'Content-Type': 'application/json; charset=utf-8',
                'access-control-allow-origin': '*'
            },
            body: JSON.stringify({
                "ID": null
            })
        })
            .then(res => res.json())
            .then((data) => {
                if (data.Status === 'OK') {
                    this.setState({ SchoolList: data.ListingDetail });
                }
            })
            .catch(console.log);
    }

    getTheme() {
        fetch(this.state.apiUrl + '/ChallengeAPI/GetLatestChallenge', {
            method: 'POST',
            headers: {
                'token': process.env.REACT_APP_API_TOKEN,
                'Content-Type': 'application/json; charset=utf-8',
                'access-control-allow-origin': '*'
            }
        })
            .then(res => res.json())
            .then((data) => {
                if (data.Status === 'OK') {
                    fetch(this.state.apiUrl + '/CommonAPI/GetTheme', {
                        method: 'POST',
                        headers: {
                            'token': process.env.REACT_APP_API_TOKEN,
                            'Content-Type': 'application/json; charset=utf-8',
                            'access-control-allow-origin': '*'
                        },
                        body: JSON.stringify({
                            "ID": null,
                            "Challenge_ID": data.Challenge_ID,
                            "Start_Index": 1,
                            "Max_Rows": 1000
                        })
                    })
                        .then(res => res.json())
                        .then((themeData) => {
                            if (themeData.Status === 'OK') {
                                this.setState({ ThemeList: themeData.ListingDetail });
                            } else {
                                this.setState({ ThemeList: [] });
                            }
                        })
                        .catch(console.log);
                }

            })
            .catch(console.log);

    }

    submitForm(e) {
        e.preventDefault();
        var isAbletoSubmit = false;
        var checkSubmission = [];
        let FormData = this.state.FormData;
        FormData.forEach(function (item, index) {
            item.touched = true;
            if (item.isRequired && item.touched && item.value === "") {
                checkSubmission.push(false);
            }
        });

        this.setState({ FormData: FormData });
        var serialize = require('form-serialize');
        var form = this.SubmitForm;
        var obj = serialize(form, { hash: true });

        if (checkSubmission.length > 0) {
            isAbletoSubmit = false;
        } else {
            isAbletoSubmit = true;
        }
        if (isAbletoSubmit) {
            this.props.FormSubmit(obj, true);
        } else {
            this.props.FormSubmit(obj, false);
        }
    }

    componentDidMount() {
        this.GetSchool();
        this.getCountry();
        this.GetProject();
        this.getTheme();
        this.SubmitForm.reset();
        // localStorage.removeItem('struckey');
        // localStorage.removeItem('titlekey');
        // localStorage.removeItem('desckey');
        // localStorage.removeItem('stk');
        // localStorage.removeItem('ptk');
        // localStorage.removeItem('ctk');
        // localStorage.removeItem('bnk');
        // localStorage.removeItem('lnk');
        // localStorage.removeItem('sdk');
        // localStorage.removeItem('edk');
        // localStorage.removeItem('fbk');
        // localStorage.removeItem('igk');
    }

    render() {
        const popover = (
            <Popover id="popover-basic">
                <Popover.Title as="h3">Instructions and Notes</Popover.Title>
                <Popover.Content>
                    <ol className="list-unstyle pl-3">
                        <li className="mb-2">When submitting story during the challenge participation period, this picture and caption will be used as your submission for the challenge.</li>
                        <li className="mb-2">More information and FAQs about the challenge can be found <Link className="text-link" target="_blank" to={`/challenge`}>here</Link></li>
                        <li className="mb-2">Photos submitted should be in landscape and in JPEG format. Photo submitted need to be in the size of 1MB and in the (1920x1080) resolution.</li>
                        <li className="mb-2">Your photo caption should be relevant to the photo banner, theme of the challenge and kept to a maximum of 25 words.</li>
                    </ol>
                </Popover.Content>
            </Popover>
        );

        return (
            <form className="w-100" ref={el => this.SubmitForm = el} onSubmit={(e) => this.submitForm(e)}>
                <div className="d-flex justify-content-end align-items-center my-3">
                    {/* <Link to={'/preview'} target="_blank" className="btn btn-outline-primary mr-2" onClick={this.GoToPreview}>Preview</Link> */}
                    <button to={'/preview'} type="button" className="btn btn-outline-primary mr-2" onClick={this.GoToPreview}>Preview</button>
                    <button type="submit" className="btn btn-outline-primary mr-2" >Create</button>
                    {/* <button className="btn btn-primary" onClick={this.handlePublishModal}>Publish</button> */}
                </div>
                <div className="d-flex justify-content-start w-100">
                    <h2 className="color_113F70">Create Your Story</h2>
                    {/* <div>
                        <OverlayTrigger trigger="click" placement="right" overlay={popover}>
                            <img src="./images/info.png" className="icons-md cursor_pointer" />
                        </OverlayTrigger>

                    </div> */}
                </div>
                <div className="pt-2 mb-5">
                    <div><b>Instructions and Notes</b><span className="text-danger">*</span></div>
                    <ol className="list-unstyle pl-3">
                        <li className="mb-2">Submit a story only if you are a YEP or YEP-GO team.</li>
                        <li className="mb-2">Complete all 3 sections of “Submit Story” as part of your YEP or YEP-GO closure requirements.</li>
                        <li className="mb-2">Your submitted story will take approximately 1 week to be approved and published. Incomplete or unsatisfactory submissions will be rejected and has to be resubmitted.</li>
                    </ol>
                </div>

                <div>
                    <h3 className="color_113F70">Personal and Project Information</h3>
                </div>
                <div className="table-form mt-3" id="customLayoutForm">
                    <div>
                        {
                            this.state.FormData.map((data, index) => {
                                if (data.condition === '') {
                                    if (data.type === 'dropdown') {
                                        return (
                                            <div key={index} className="mb-3">
                                                <div className="mb-1">{data.label} {data.isRequired && <span className="text-danger">*</span>}</div>
                                                <div>
                                                    <div>
                                                        <select onChange={(e) => this.handleFieldValue(e, index)} ref={el => this[`${data.name}`] = el} name={data.name} defaultValue={data.value} className={data.isRequired && data.touched && data.value === "" ? 'is-invalid ' + data.className : data.className}>
                                                            <option value="">Please select...</option>
                                                            {
                                                                data.label === 'Country' && this.state.CountryList.map((option, optIndex) => {
                                                                    return (
                                                                        <option key={optIndex} value={option.Listing_ID}>{option.Listing_Name}</option>
                                                                    );
                                                                })

                                                            }
                                                            {
                                                                data.label === 'Organization' && this.state.SchoolList.map((option, optIndex) => {
                                                                    return (
                                                                        <option key={optIndex} value={option.Listing_ID}>{option.Listing_Name}</option>
                                                                    );
                                                                })
                                                            }
                                                            {
                                                                data.label === 'Project' && this.state.ProjectList.map((option, optIndex) => {
                                                                    return (
                                                                        <option key={optIndex} value={option.Listing_ID}>{option.Listing_Name}</option>
                                                                    );
                                                                })
                                                            }
                                                            {
                                                                data.label === 'Theme' && this.state.ThemeList.map((option, optIndex) => {
                                                                    return (
                                                                        <option key={optIndex} value={option.Listing_ID}>{option.Listing_Name}</option>
                                                                    );
                                                                })
                                                            }

                                                        </select>
                                                        {data.isRequired && data.touched && data.value === "" && <small className="text-danger">{data.errorMessage}</small>}
                                                    </div>
                                                </div>
                                            </div>
                                        );
                                    } else if (data.type === 'text' || data.type === 'email' || data.type === 'number') {
                                        return (
                                            <div className="mb-3" key={index}>
                                                <div className="mb-1">{data.label} {data.isRequired && <span className="text-danger">*</span>}</div>
                                                <div>
                                                    <div>
                                                        <input readOnly={data.isReadOnly} ref={el => this[`${data.name}`] = el} name={data.name} defaultValue={data.value} onBlur={(e) => this.handleFieldValue(e, index, data.name)} className={data.isRequired && data.touched && data.value === "" ? 'is-invalid ' + data.className : data.className} type={data.type} placeholder={data.placeholder} />
                                                        {data.isRequired && data.touched && data.value === "" && <small className="text-danger">{data.errorMessage}</small>}
                                                    </div>
                                                </div>
                                            </div>
                                        );
                                    } else if (data.type === 'date') {
                                        return (
                                            <div className="mb-3" key={index}>
                                                <div className="mb-1">{data.label} {data.isRequired && <span className="text-danger">*</span>}</div>
                                                <div>
                                                    <div>

                                                        <input readOnly={data.isReadOnly} ref={el => this[`${data.name}`] = el} name={data.name} defaultValue={Moment(data.value).format('YYYY-MM-DD')} onBlur={(e) => this.handleFieldValue(e, index)} className={data.isRequired && data.touched && data.value === "" ? 'is-invalid ' + data.className : data.className} type={data.type} placeholder={data.placeholder} />
                                                        {data.isRequired && data.touched && data.value === "" && <small className="text-danger">{data.errorMessage}</small>}
                                                    </div>
                                                </div>
                                            </div>
                                        );
                                    } else if (data.type === 'file') {
                                        return (
                                            <div className="mb-3" key={index}>
                                                {data.name === 'BannerImage' &&
                                                    <div className="d-flex justify-content-start w-100 mt-5">
                                                        <h3 className="color_113F70">Photo Banner</h3>
                                                        <div>
                                                            <OverlayTrigger trigger="click" placement="top" overlay={popover}>
                                                                <img src="./images/info.png" className="icons-md cursor_pointer" />
                                                            </OverlayTrigger>
                                                        </div>
                                                    </div>
                                                }
                                                {/* <div className="mb-1">{data.label} {data.isRequired && <span className="text-danger">*</span>}</div> */}
                                                {data.name === 'BannerImage' && <div><small>Required landscape and resolution 1920x1080 for best fit<span className="text-danger">*</span></small></div>}
                                                <div>
                                                    <div>
                                                        <input accept=".jpg, .png" className={data.isRequired && data.touched && data.value === "" ? 'is-invalid ' + data.className : data.className} type={data.type} ref={el => this[`${data.name}`] = el} name={data.name} onChange={(e) => this.fileUpload(e, index)} />
                                                        {data.isRequired && data.touched && data.value === "" && <small className="text-danger">{data.errorMessage}</small>}

                                                    </div>
                                                    <div>
                                                        <img id="loadImage" className="img-fluid" />
                                                    </div>
                                                </div>
                                            </div>

                                        );
                                    } else if (data.type === 'checkbox') {
                                        return (
                                            <div className="mb-3" key={index}>
                                                <div>{data.label}</div>
                                                <div>
                                                    <div>
                                                        <label>
                                                            <input ref={el => this[`${data.name}`] = el} name={data.name} onChange={(e) => this.handleFieldValue(e, index)} className="mr-2" type={data.type} />
                                                            {data.isRequired && data.touched && data.value === "" && <small className="text-danger">{data.errorMessage}</small>}
                                                            {data.label} {data.isRequired && <span className="text-danger">*</span>}

                                                        </label>
                                                    </div>
                                                </div>
                                            </div>
                                        );
                                    }
                                }
                                else if (data.condition === 'JoditEditor') {
                                    return (
                                        <div className="mb-3" key={index}>
                                            <div className="mb-1">{data.label} {data.isRequired && <span className="text-danger">*</span>}</div>
                                            {data.name === 'Story_Description' && <div><small>Word limit 200<span className="text-danger">*</span></small></div>}
                                            <div>
                                                <JoditEditor config={this.state.config} onChange={(e) => this.handleJoditField(e, index)} value={data.value} ref={el => this[`${data.name}`] = el} />
                                                {data.isRequired && data.touched && data.value === "" && <small className="text-danger">{data.errorMessage}</small>}
                                            </div>
                                        </div>
                                    );
                                } else if (data.condition === 'textarea') {
                                    return (
                                        <div className="mb-3" key={index}>
                                            <div className="mb-1">{data.label} {data.isRequired && <span className="text-danger">*</span>}</div>
                                            {/* {data.name === 'Story_Description' && <div><small>Word limit 60<span className="text-danger">*</span></small></div>} */}
                                            <div>
                                                <textarea name={data.name} rows="5" onChange={(e) => this.handleFieldValue(e, index)} value={data.value} ref={el => this[`${data.name}`] = el} className={data.isRequired && data.touched && data.value === "" ? 'is-invalid ' + data.className : data.className}></textarea>
                                                {/* <JoditEditor config={this.state.config} onChange={(e) => this.handleJoditField(e, index)} value={data.value} ref={el => this[`${data.name}`] = el} /> */}
                                                {data.isRequired && data.touched && data.value === "" && <small className="text-danger">{data.errorMessage}</small>}
                                            </div>
                                        </div>
                                    );
                                } else if (data.condition === 'Display') {
                                    return (
                                        <div key={index}>
                                            <div className="mb-1">{data.label}</div>
                                            <div>
                                                {data.value}
                                            </div>
                                        </div>
                                    );
                                }
                            })

                        }
                    </div>
                </div>

            </form>
        );
    }
}

export default FormData;

